<template>
  <div class="row">
    <div class="col-12">
      <div class="card-body">
        <div class="row m-b-0">
          <div class="col-lg-12">
            <div v-if="audit" class="row m-b-0">
              <audit-header-col title="Status">
                <status :status="audit.status" />
              </audit-header-col>
              <audit-header-col title="Audit Creator">
                <address-book-by-public-key v-if="audit.audit_creator" :public-key="audit.audit_creator" />
              </audit-header-col>
              <audit-header-col title="Auditor / Verifier">
                <address-book-by-public-key v-if="audit.auditing_org" :public-key="audit.auditing_org" />
              </audit-header-col>
              <audit-header-col title="Certification">
                {{ audit.certification_name }}
              </audit-header-col>
              <audit-header-col title="Created On">
                {{ audit.created_at | date }}
              </audit-header-col>
              <audit-header-col title="Transaction">
                <a data-target="#proposalModal" data-toggle="modal" href="javascript:void(0)" target="_blank" @click="proposal_id = audit.proposal_id">Click here to view details</a>
              </audit-header-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressBookByPublicKey from '@/components/protected/common/AddressBookByPublicKey'
import Status from '@/components/protected/common/Status.vue'
import AuditHeaderCol from './AuditHeaderCol.vue'

export default {
  name: 'AuditHeader',
  components: { Status, AddressBookByPublicKey, AuditHeaderCol },
  props: ['audit']
}
</script>

<style scoped>
</style>
